import type { InsertUserGroupUsersMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

type InsertUserGroupUsersInput = {
  objects: { UserGroupId: string; UserId: string }[];
};

const mapTrpcResponseToGraphQL = (trpcData: {
  affected_rows: number;
}): InsertUserGroupUsersMutation => ({
  insert_user_group_user: {
    __typename: 'user_group_user_mutation_response',
    affected_rows: trpcData.affected_rows,
  },
});

export const useInsertUserGroupUsersTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.userGroup.insertUsers.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.userGroup.usersByGroupId.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.userGroup.userGroupsWithApprovers.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.userGroup.userGroupById.queryKey(),
        });
      },
    }),
  });

  return {
    insertUserGroupUsers: async (
      variables: InsertUserGroupUsersInput
    ): Promise<InsertUserGroupUsersMutation> => {
      const result = await mutation.mutateAsync(variables);

      return mapTrpcResponseToGraphQL(result);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
